module.exports = __webpack_public_path__ + "static/img/ts.1c905138.png";